import * as React from "react";
import { useCpFormValue } from "../../../gvc/testNewForm/utils";
import { DetectedTags } from "../../../../components/detail/detectedTags";
import { inputToTags } from "../../../../mst/kinds/utils";

interface Props {
  name: string;
}
export const NodePoolDetectedTags: React.FC<Props> = ({ name }) => {
  const isCreate = useCpFormValue(`meta.isCreate`);
  const labels = useCpFormValue(name);

  if (isCreate) {
    return null;
  }

  return (
    <div style={{ maxWidth: 900 }}>
      <DetectedTags
        value={inputToTags(labels)}
        detectValue={(tags, key) => tags.hasOwnProperty(key)}
        detectionMap={
          name.includes(".aws.") || name.includes(".gcp.")
            ? {
                "cpln.io/nodeType": "if value is core: nodes can accept BYOK core components",
                "cpln.io/refreshToken": "changes to this tag cause refresh of the ASG",
              }
            : {
                "cpln.io/nodeType": "if value is core: nodes can accept BYOK core components",
              }
        }
        pluralLabel="Labels"
      />
    </div>
  );
};
